import {
  type UpdateTransportRequestOnrApiMutationOptions,
  useUpdateTransportRequestOnrApi,
} from './mutation/useUpdateTransportRequestOnrApi.ts'

export interface OnboardTransportRequestApiVariables {
  regionId: string
  transportRequestId: string
}

export const useOnboardTransportRequest = (
  options?: UpdateTransportRequestOnrApiMutationOptions<void, OnboardTransportRequestApiVariables>
) =>
  useUpdateTransportRequestOnrApi<void, OnboardTransportRequestApiVariables>({
    type: 'piloteOnboardTransportRequest',
    ...options,
  })
